import { z } from "zod";

import { OrderDirection } from "@/constants/orderDirection";

import { ORDER_BY } from "./-types";

export const SearchSchema = z.object({
  freeText: z.string().optional(),
  showDisabled: z.boolean().default(false),
  sortColumn: z.nativeEnum(ORDER_BY).optional(),
  sortOrder: z.nativeEnum(OrderDirection).optional(),
});
